import styled from "styled-components";
import { palette } from "styled-theme";

const FormHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid ${palette("border", 0)};
  margin-bottom: 20px;
`;

export default FormHeaderWrapper;
